// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#careimage-list[data-v-ff19ac14]{max-width:1280px;margin-left:auto;margin-right:auto}#careimage-list .note[data-v-ff19ac14]{margin:0 0 8px 0}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
